import { combineReducers } from "redux";

import utils from "./utils";
import auth from "./auth";
import modules from "./modules";
import resources from "./resources";
import carts from "./carts";
import inventory from "./inventory";
import register from "./register";
import locations from "./locations";

export default combineReducers({
  utils,
  auth,
  modules,
  resources,
  carts,
  inventory,
  register,
  locations,
});